import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import AccountLog from '../../common/AccountLog';

/** /account-log: «Журнал изменений аккаунтов» for admins and the group «Техподдержка». */
export default class AccountLogPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    if (!app.forum.attribute('ppk2CanViewAccountLog')) {
      m.route.set(app.route('index'));
      return;
    }
    app.setTitle(app.translator.trans('ppk2-profile.lib.account_log.log_title'));
  }
  view() {
    return m("div", {
      className: "Ppk2AccountLogPage"
    }, m("div", {
      className: "container"
    }, m("h2", null, app.translator.trans('ppk2-profile.lib.account_log.log_title')), app.forum.attribute('ppk2CanViewAccountLog') ? m(AccountLog, null) : null));
  }
}
flarum.reg.add('ppk2-profile', 'forum/components/AccountLogPage', AccountLogPage);